import { getString } from "../../common/common";

export const HEADING1 = "HEADING1";
export const POINT1 = "POINT1";

export const T1_I1 = "T1_I1";
export const T1_I2 = "T1_I2";
export const T1_I3 = "T1_I3";
export const T1_I4 = "T1_I4";
export const T1_I5 = "T1_I5";
export const T1_I6 = "T1_I6";
export const T1_I7 = "T1_I7";
export const T1_I8 = "T1_I8";

export const POINT2 = "POINT2";
export const T2_R1C1 = "T2_R1C1";
export const T2_R1C2 = "T2_R1C2";
export const T2_R2C1 = "T2_R2C1";
export const T2_R2C2 = "T2_R2C2";
export const T2_R3C1 = "T2_R3C1";
export const T2_R3C2 = "T2_R3C2";
export const T2_R4C1 = "T2_R4C1";
export const T2_R4C2 = "T2_R4C2";
export const POINT3 = "POINT3";
export const POINT3_LI1 = "POINT3_LI1";
export const POINT3_LI2 = "POINT3_LI2";
export const POINT3_LI3_1 = "POINT3_LI3_1";
export const POINT3_LI3_2 = "POINT3_LI3_2";
export const POINT3_LI3_3 = "POINT3_LI3_3";
export const POINT4 = "POINT4";

export const POIN43_LI1 = "POINT4_LI1";
export const POIN43_LI2 = "POINT4_LI2";
export const POIN43_LI3 = "POINT4_LI3";
export const POIN43_LI4 = "POINT4_LI4";

export const translations = {
  en: {
    [HEADING1]: "KSRTC:Procurement Procedure & Statistics",
    [POINT1]:
      "1) KSRTC purchases various items required for the day to day operations of all the corporations viz., KSRTC, BMTC, NWKRTC & NEKRTC. The major procurement is as detailed:",
    [T1_I1]: "HSD (Diesel)",
    [T1_I2]: "Spare Parts",
    [T1_I3]: "Tyre, Tube & Flaps",
    [T1_I4]: "Lubricants",
    [T1_I5]: "Battery & other Consumables",
    [T1_I6]: "Tyre Retreading Materials",
    [T1_I7]: "Uniform , Line Equipment & Other Stationery",
    [T1_I8]: "Total",
    [POINT2]:
      "2) KSRTC purchases various items required for the day to day operations of all the corporations viz., KSRTC, BMTC, NWKRTC & NEKRTC. The major procurement is as detailed:",
    [T2_R1C1]: "Diesel",
    [T2_R1C2]:
      "Indian Oil Corporation (I.O.C), Hindustan Petroleum Corporation (H.P.C) (Govt.of India undertakings)",
    [T2_R2C1]: "Steel",
    [T2_R2C2]:
      "Steel Authority of India Limited (SAIL) (Govt.of India undertaking)",
    [T2_R3C1]: "Lubricants",
    [T2_R3C2]:
      "Hindustan Petroleum Corporation, Indian Oil Corporation (I.O.C), (Govt.of India undertakings) Karol Lubricants (Local industry)",

    [T2_R4C1]: "Automobile Spares",
    [T2_R4C2]:
      "TATA Motors, Ashok Leyland, Volvo, Mercedes Benz, Carona, Bosch, Swaraj Mazda, TVS Groups, and others",
    [POINT3]: "3) PROCUREMENT DETAILS:",

    [POINT3_LI1]:
      "The Karnataka Transparency in Public Procurement Act, 2000 is implemented in all the purchases.",
    [POINT3_LI2]: "All purchases are through e-Procurement only.",
    [POINT3_LI3_1]:
      "Procurement tenders are processed through the e-procurement portal of e-governance department, Govt. Karnataka through website",
    [POINT3_LI3_2]: "www.eproc.karnataka.gov.in.",
    [POINT3_LI3_3]: ".",

    [POINT4]: "4) SCRAP DISPOSAL:",

    [POIN43_LI1]:
      "Scrap buses, Tyres, Rubber, M.S., Aluminum etc., are disposed through public E-Tender cum auction.",
    [POIN43_LI2]:
      "Tender-cum-auction will be held every month alternatively at Bangalore, Hubli, and Gulbarga.",
    [POIN43_LI3]:
      "The corporation has realized Rupees 98 Crores through the sale of scrap materials & buses for the financial year 2013-14.",
    [POIN43_LI4]:
      "The corporation also sells buses in running condition to educational institutions at a concessional rate. These are used to transport the students.",
  },
  kn: {
    [HEADING1]: "KSRTC: ಸಂಗ್ರಹಣೆ ಪ್ರಕ್ರಿಯೆ ಮತ್ತು ಅಂಕಿಅಂಶಗಳು",
    [POINT1]:
      "1) KSRTC ಎಲ್ಲಾ ದಿನನಿತ್ಯದ ಕಾರ್ಯಾಚರಣೆಗಳಿಗೆ ಅಗತ್ಯವಿರುವ ವಿವಿಧ ವಸ್ತುಗಳನ್ನು ಖರೀದಿಸುತ್ತದೆ ನಿಗಮಗಳು ಅಂದರೆ, KSRTC, BMTC, NWKRTC & NEKRTC. ಪ್ರಮುಖ ಸಂಗ್ರಹಣೆಯನ್ನು ವಿವರಿಸಲಾಗಿದೆ:",
    [T1_I1]: "HSD (ಡೀಸೆಲ್)",
    [T1_I2]: "ಬಿಡಿ ಭಾಗಗಳು",
    [T1_I3]: "ಟೈರ್, ಟ್ಯೂಬ್ ಮತ್ತು ಫ್ಲಾಪ್‌ಗಳು",
    [T1_I4]: "ಲೂಬ್ರಿಕೆಂಟ್ಸ್",
    [T1_I5]: "ಬ್ಯಾಟರಿ ಮತ್ತು ಇತರ ಸೇವಿಸುವ ವಸ್ತುಗಳು",
    [T1_I6]: "ಟೈರ್ ರಿಟ್ರೆಡಿಂಗ್ ಮೆಟೀರಿಯಲ್ಸ್",
    [T1_I7]: "ಸಮವಸ್ತ್ರ, ಲೈನ್ ಸಲಕರಣೆ ಮತ್ತು ಇತರೆ ಸ್ಟೇಷನರಿ",
    [T1_I8]: "ಒಟ್ಟು",
    [POINT2]:
      "2) KSRTC ಎಲ್ಲಾ ದಿನನಿತ್ಯದ ಕಾರ್ಯಾಚರಣೆಗಳಿಗೆ ಅಗತ್ಯವಿರುವ ವಿವಿಧ ವಸ್ತುಗಳನ್ನು ಖರೀದಿಸುತ್ತದೆ ನಿಗಮಗಳು ಅಂದರೆ, KSRTC, BMTC, NWKRTC & NEKRTC. ಪ್ರಮುಖ ಸಂಗ್ರಹಣೆಯನ್ನು ವಿವರಿಸಲಾಗಿದೆ:",
    [T2_R1C1]: "ಡೀಸೆಲ್",
    [T2_R1C2]:
      "ಇಂಡಿಯನ್ ಆಯಿಲ್ ಕಾರ್ಪೊರೇಷನ್ (I.O.C), ಹಿಂದೂಸ್ತಾನ್ ಪೆಟ್ರೋಲಿಯಂ ಕಾರ್ಪೊರೇಷನ್ (H.P.C) (ಭಾರತ ಸರ್ಕಾರದ ಉದ್ಯಮಗಳು)",
    [T2_R2C1]: "ಸ್ಟೀಲ್",
    [T2_R2C2]:
      "ಸ್ಟೀಲ್ ಅಥಾರಿಟಿ ಆಫ್ ಇಂಡಿಯಾ ಲಿಮಿಟೆಡ್ (SAIL) (ಭಾರತದ ಸರ್ಕಾರ ಅಂಡರ್‌ಟೇಕಿಂಗ್)",

    [T2_R3C1]: "ಲೂಬ್ರಿಕೆಂಟ್ಸ್",
    [T2_R3C2]:
      "ಹಿಂದೂಸ್ತಾನ್ ಪೆಟ್ರೋಲಿಯಂ ಕಾರ್ಪೊರೇಶನ್, ಇಂಡಿಯನ್ ಆಯಿಲ್ ಕಾರ್ಪೊರೇಷನ್ (I.O.C), (ಭಾರತದ ಸರ್ಕಾರಗಳು) ಕರೋಲ್ ಲೂಬ್ರಿಕಂಟ್ಸ್ (ಸ್ಥಳೀಯ ಉದ್ಯಮ)",
    [T2_R4C1]: "ಆಟೋಮೊಬೈಲ್ ಬಿಡಿಭಾಗಗಳು",
    [T2_R4C2]:
      "TATA ಮೋಟಾರ್ಸ್, ಅಶೋಕ್ ಲೇಲ್ಯಾಂಡ್, ವೋಲ್ವೋ , ಮರ್ಸಿಡಿಸ್ ಬೆಂಜ್ , ಕೊರೊನ, ಬಾಷ್ , ಸ್ವರಾಜ್ ಮಜ್ದಾ , TVS ಗ್ರೂಪ್ , ಮತ್ತು ಇತರರು",
    [POINT3]: "3) ಸಂಗ್ರಹಣೆ ವಿವರಗಳು:",

    [POINT3_LI1]:
      "ಸಾರ್ವಜನಿಕ ಸಂಗ್ರಹಣೆಯಲ್ಲಿ ಕರ್ನಾಟಕ ಪಾರದರ್ಶಕತೆ ಕಾಯಿದೆ, 2000 ಅನ್ನು ಎಲ್ಲಾ ಖರೀದಿಗಳಲ್ಲಿ ಅಳವಡಿಸಲಾಗಿದೆ.",

    [POINT3_LI2]: "ಎಲ್ಲಾ ಖರೀದಿಗಳು ಇ-ಪ್ರೊಕ್ಯೂರ್‌ಮೆಂಟ್ ಮೂಲಕ ಮಾತ್ರ.",

    [POINT3_LI3_1]:
      "ಸರ್ಕಾರದ ಇ-ಆಡಳಿತ ಇಲಾಖೆಯ ಇ-ಪ್ರೊಕ್ಯೂರ್‌ಮೆಂಟ್ ಪೋರ್ಟಲ್ ಮೂಲಕ ಖರೀದಿ ಟೆಂಡರ್‌ಗಳನ್ನು ಪ್ರಕ್ರಿಯೆಗೊಳಿಸಲಾಗುತ್ತದೆ. ವೆಬ್‌ಸೈಟ್",
    [POINT3_LI3_2]: "www.eproc.karnataka.gov.in",
    [POINT3_LI3_3]: "ಮೂಲಕ ಕರ್ನಾಟಕ.",

    [POINT4]: "4) ಗುಜರಿ ವಸ್ತುಗಳ ವಿಲೇವಾರಿ:",
    [POIN43_LI1]:
      "ಸ್ಕ್ರ್ಯಾಪ್ ಬಸ್‌ಗಳು, ಟೈರುಗಳು, ರಬ್ಬರ್, M.S., ಅಲ್ಯೂಮಿನಿಯಂ ಇತ್ಯಾದಿಗಳನ್ನು ಸಾರ್ವಜನಿಕ ಇ-ಟೆಂಡರ್ ಕಮ್ ಹರಾಜು ಮೂಲಕ ವಿಲೇವಾರಿ ಮಾಡಲಾಗುತ್ತದೆ.",
    [POIN43_LI2]:
      "ಬೆಂಗಳೂರು, ಹುಬ್ಬಳ್ಳಿ ಮತ್ತು ಗುಲ್ಬರ್ಗದಲ್ಲಿ ಪ್ರತಿ ತಿಂಗಳು ಪರ್ಯಾಯವಾಗಿ ಟೆಂಡರ್-ಕಮ್-ಹರಾಜು ನಡೆಯಲಿದೆ.",
    [POIN43_LI3]:
      "2013-14ನೇ ಹಣಕಾಸು ವರ್ಷದಲ್ಲಿ ಸ್ಕ್ರ್ಯಾಪ್ ಸಾಮಗ್ರಿಗಳು ಮತ್ತು ಬಸ್‌ಗಳ ಮಾರಾಟದ ಮೂಲಕ ನಿಗಮವು 98 ಕೋಟಿ ರೂಪಾಯಿಗಳನ್ನು ಗಳಿಸಿದೆ.",
    [POIN43_LI4]:
      "ನಿಗಮವು ಚಾಲನೆಯಲ್ಲಿರುವ ಬಸ್‌ಗಳನ್ನು ಸಹ ಶಿಕ್ಷಣ ಸಂಸ್ಥೆಗಳಿಗೆ ರಿಯಾಯಿತಿ ದರದಲ್ಲಿ ಮಾರಾಟ ಮಾಡುತ್ತದೆ. ಇವುಗಳನ್ನು ವಿದ್ಯಾರ್ಥಿಗಳನ್ನು ಸಾಗಿಸಲು ಬಳಸಲಾಗುತ್ತದೆ.",
  },
};

export const t = (key = "") => {
  return getString(key, translations);
};
